type Env = "test" | "dev" | "prod"; // Define the possible environments

// Configuration interface
interface Config {
    BaseUrl: string;
    recaptchaKey: string;
    minStakeAmount: number;
}

// Define the current environment
export const env: Env = "test"; // Replace "test" with the desired environment

// Environment-specific configurations
const config: Record<Env, Config> = {
    test: {
        BaseUrl: "https://c6d0-2401-4900-1c0f-fd17-c52a-794d-1924-3e7.ngrok-free.app/",
        recaptchaKey: "6LevEMMZAAAAAGXRlbr2ysHkjK-WcqesUFD1UcGN",
        minStakeAmount: 100,
    },
    dev: {
        BaseUrl: "http://192.168.1.59:9900/",
        recaptchaKey: "6LevEMMZAAAAAGXRlbr2ysHkjK-WcqesUFD1UcGN",
        minStakeAmount: 100,
    },
    prod: {
        BaseUrl: "https://api.agrifi.app/",
        recaptchaKey: "6LevEMMZAAAAAGXRlbr2ysHkjK-WcqesUFD1UcGN",
        minStakeAmount: 100,
    },
};

// Ensure the selected environment has valid configuration
if (!config[env]) {
    throw new Error(`Invalid environment configuration for: ${env}`);
}

// Extract environment-specific keys
const keys = {
    api_key: config[env].BaseUrl,
    Recaptchakey: config[env].recaptchaKey,
    minStake: config[env].minStakeAmount,
};

// Export the keys and configuration for use in other parts of the application
export default keys;







/* let env = "test"

const config = {
    test: {
        BaseUrl: "https://ceewen.xyz:9900/"
    },
    dev: {
        BaseUrl: "http://192.168.1.59:9900/"
    },
    prod: {
        //    api:"https://dummyjson.com/"
    }
}
const keys = {
    api_key: config[env].BaseUrl,
    defaultLn: "en"
}

export default keys */